// Angular
import { CommonModule, Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Renderer2,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  AfterViewInit,
  NgZone,
  HostListener,
  ViewChild
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Ionic
import {
  IonApp, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList,
  IonMenu, IonMenuButton, IonMenuToggle, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs,
  IonTitle, IonToolbar, IonSelect, IonPopover, LoadingController, PopoverController,
  ToastController, Platform, AlertController, ModalController, NavController, IonSelectOption,
  IonModal, IonToggle, IonAccordion, IonAccordionGroup, IonTextarea, IonToast
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';

// Capacitor
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';

// Third party
import { Subscription, catchError, filter, interval, take, throwError } from 'rxjs';
import { NativeSettings, AndroidSettings } from 'capacitor-native-settings';
import { Smartlook } from '@awesome-cordova-plugins/smartlook/ngx';

// Local library
import {
  CommonFacade, ENABLE_COMPONENT_VIEW, ENVIRONMENT, PermissionService, PusherService, SessionService, ToteProgramAPIService
} from '@amwager/data-access';
import { AuthFacade } from '@amwager/authentication/data-access';

// Local file
import { TabsSectionPageComponent } from './tabs/tabs.section';
import { AccountPopOverComponent } from './account-pop-over/account-pop-over.component';
import {
  ShowMessageToCompleteRegistrationComponent
} from './show-message-to-complete-registration/show-message-to-complete-registration.component';
import {
  ShowMessageToVerifiyDocumentsComponent
} from './show-message-to-verifiy-documents/show-message-to-verifiy-documents.component';
import { ProfileComponent } from '@amwager/account/feature-ion';
import { ISelectedRace, ITicketSlim, WagerFacade } from '@amwager/wager/data-access';
import { INACTIVE, ICounterModel, IGeoLocationModel, IGetEventsDetailsResponse, IPusher, IToteResultResponse, STATUS_ACTIVE, STATUS_CLOSE, STATUS_STACK, sortEvents, isOnline, NO_INTERNET } from '@amwager/util-ts';

import * as _ from 'lodash';
import { TicketFacade } from '@amwager/ticket/data-access';
import { AccountFacade } from '@amwager/account/data-access';
import {
  GeoLocationService,
  InactivityService,
  NumberWithCommasPipe,
  SanitizerPipe
} from '@amwager/util';
import { FundingComponent } from '@amwager/funding/feature-ion';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PlayVideoComponent } from '@amwager/wager/feature-ion';
import { FundingFacade } from '@amwager/funding/data-access';


@Component({
  selector: 'amwager3-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonApp,
    IonRouterOutlet,
    IonContent,
    IonMenu,
    IonHeader,
    IonTabBar,
    IonToolbar,
    IonTitle,
    IonButton,
    IonMenuButton,
    IonButtons,
    IonTabs,
    IonTabButton,
    IonIcon,
    IonList,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonMenuToggle,
    IonPopover,
    IonModal,
    IonToggle,
    TabsSectionPageComponent,
    CommonModule,
    FormsModule,
    IonAccordion,
    IonAccordionGroup,
    IonTextarea,
    NumberWithCommasPipe,
    SanitizerPipe,
    IonToast
  ],
  providers: [
    ToteProgramAPIService
  ]
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  // for Development purposes only, if enable test component view for routes
  isComponentView?: boolean;

  @ViewChild('betSummary') betSummaryDiv!: ElementRef;
  // @ViewChild('amwagerLogo') amwagerLogo!: ElementRef<HTMLDivElement>;
  // @ViewChild('amountBalance') amountBalance!: ElementRef<HTMLDivElement>;

  geoLocation!: IGeoLocationModel;
  private subsGetCounterResponse!: Subscription;
  private getSelectedEventTrackSubs?: Subscription;
  private intervalConnectivitySubs?: Subscription;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  profileModal!: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TicketCounter!: any;
  stackedTicketAmount!: number;
  activeTicketAmount!: number;
  closeTicketAmount!: number;
  closeEarnings!: number;

  betSummary!: boolean;
  stackTodaySum!: string;
  betTodaySum!: string;
  wonTodaySum!: string;
  profitLossSum!: string;
  activeBetsSum!: string;
  realTimePlSum!: string;

  amWagerTheme!: number;

  // for QA purpose only, for bug tracking
  isQAModalOpen = false;
  qaTesting = {
    showStatusCodeInToastMessage: false,
    showMessageCodeInToastMessage: false,
    showMessageInToastMessage: false,
  };

  qaTestingSelectedFile: File | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  qaTestingOnFileSelected(event: any) {
    this.pusherService.disconnect();
    this.wagerFacade.updateEventsDetails([]);

    this.qaTestingSelectedFile = event.target.files[0];

    if (this.qaTestingSelectedFile) {
      const reader = new FileReader();
      reader.readAsText(this.qaTestingSelectedFile);
      reader.onload = () => {
        if (reader.result) {
          try {
            const jsonData = JSON.parse(reader.result as string);


            const newData = sortEvents(
              _.map(jsonData, (eventTrackRace: IGetEventsDetailsResponse) => ({
                id: eventTrackRace?.ToteResponse?.EventDetail?.EventName, // set an id
                // ...eventTrackRace
                ...{
                  ...eventTrackRace, // event from list
                  ToteResponse: {
                    ...eventTrackRace?.ToteResponse,
                    EventDetail: {
                      ...eventTrackRace?.ToteResponse?.EventDetail,
                      currentRace: (() => {
                        // add currentRace for this event
                        return _.find(eventTrackRace?.ToteResponse?.EventDetail?.Races || [], 'Current')
                      })()
                    }
                  },
                  eventName: eventTrackRace?.ToteResponse?.EventDetail?.EventName
                }
              })),
              'MTP',
              [
                'Thoroughbred',
                'Quarterhorse',
                'Greyhound',
                'Harness',
                'International'
              ]
            )


            // console.log('qaTestingSelectedFile:', jsonData); // Display extracted JSON data in console
            this.commonFacade.setQaTesting({
              ...this.qaTesting,
              ...{ wagerCustom: newData }
            });


            this.wagerFacade.updateEventsDetails(newData);
          } catch (error) {
            console.error("Error parsing JSON:", error);
          }
        }
      };
      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };
    } else {
      console.error("No file selected.");
    }


    // console.log('qaTestingSelectedFile:', this.qaTestingSelectedFile);
  }

  qaReloadPage() {
    window.location.reload();
  }

  qaMobileReport(): void {
    window.open("reports/qa-amwager-mobile-report.html", '_blank');
  }

  isShowNavigation = false;
  isAuthenticated = false;
  themeToggle = false;
  showLoadingOverLap = false;
  userName? = '';
  darkMode = false;
  // playLiveVideo = false;
  selectedEvent!: IGetEventsDetailsResponse;
  liveVideo!: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadingModal: any;

  balance?: number;

  eventIds: any[] = [];

  myBets!: {
    saved?: ITicketSlim[];
    active?: ITicketSlim[];
    close?: ITicketSlim[];
  };

  modalVideo: any;

  alertHandler?: HTMLIonAlertElement;
  connectivity?: {
    isOpen?: boolean,
    message?: string
  };

  constructor(
    private readonly router: Router,
    private readonly platform: Platform,
    private location: Location,
    private readonly alertCtrl: AlertController,
    private readonly modalCtrl: ModalController,
    private readonly navCtrl: NavController,
    private readonly commonFacade: CommonFacade,
    private readonly ticketFacade: TicketFacade,
    private readonly authFacade: AuthFacade,
    private readonly fundingFacade: FundingFacade,
    private readonly wagerFacade: WagerFacade,
    private readonly accountFacade: AccountFacade,
    private readonly cdRef: ChangeDetectorRef,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private readonly toteProgramAPIService: ToteProgramAPIService,
    private readonly sessionService: SessionService,
    private readonly pusherService: PusherService,
    private readonly permissionService: PermissionService,
    private geoLocationService: GeoLocationService,
    private readonly inactivityService: InactivityService,
    private readonly loadingCtrl: LoadingController,
    private readonly popoverController: PopoverController,
    private readonly toastController: ToastController,
    private readonly ngZone: NgZone,
    private readonly smartlook: Smartlook,
    @Optional() private routerOutlet: IonRouterOutlet,
    @Inject(ENABLE_COMPONENT_VIEW) private readonly enableComponentView: boolean,
    @Inject(ENVIRONMENT) readonly environment: string,
  ) {
    // window DOM name
    window.name = 'amwager-mobile-app';
    // (window as any).version = '3.8.5';
    (window as any).version = '2.1.1-beta';
    console.log('APP_VERSION:', (window as any).version);

    // init state managements
    this.commonFacade.initState('AppComponent');
    this.authFacade.initState('AppComponent');
    this.wagerFacade.initState('AppComponent');
    this.ticketFacade.initState('AppComponent');
    this.accountFacade.initState('AppComponent');

    this.geolocationInterval();
    this.smartlookChecker();

    // update and re-render data if App is active
    App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) this.wagerFacade.toUpdateGeneralEvents('AppComponent:constructor');
    });

    this.checkConnectivity();

    // set if enable test component view for routes.
    // we can use `env.Environment.enableComponentView` directly but
    // for the purpose of redux tracking we are setting it to facade.
    this.commonFacade.setIsComponentView(this.enableComponentView);
    this.commonFacade.isComponentView$().subscribe((isView?: boolean) => {
      this.isComponentView = isView;
      ; // re-render for template
    });

    // QA testing
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.commonFacade.qaTesting$().subscribe((qaTesting: any) => {
      if (!qaTesting) return;
      this.qaTesting = qaTesting;
      this.cdRef.detectChanges(); // re-render for template
    });

    this.platform.ready().then(() => {
      this.initApp();
    });

    // this.authFacade.login$().subscribe((loginData?: ILogin) => {
    //   console.log('loginData:', loginData)
    //   if (loginData?.username && (loginData?.username !== GUEST)) {
    //     this.wagerFacade.getEventsDetails("AppComponent:constructor");
    //     // this.loginSubs?.unsubscribe();
    //   }
    //   // else if (loginData?.username) {
    //   //   this.wagerFacade.getEventsDetails();
    //   //   // this.loginSubs?.unsubscribe();
    //   // }
    // });

    this.wagerFacade.getSelectEventTrackRaceIds$().subscribe((ids) => {
      this.eventIds = ids;
    });

    this.wagerFacade.getBets$()
      .subscribe((response) => {
        if (_.isEmpty(response)) return;

        this.myBets = response;
      });

    this.commonFacade.getPusherData$()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .subscribe((pusher: {
        command: string,
        data: IPusher
      }) => {
        // console.log('pusher:', pusher)
        // console.log('pusher:', this.eventIds)

        const command = pusher?.command;
        const data = pusher?.data;
        const tickets = ['SST', 'STI', 'STS', 'STR', 'TIC', 'TP'];

        let service = {};

        if (!command) return;

        // check if to proceed process or not if EventId from pusher does not exist in app
        if (!this.eventIds.includes(data?.EventId)) { // if does not exist
          if (['BAL'].includes(command)) null; // proceed
          else if (!tickets.includes(command)) return; // not to proceed
        }

        if (['STI', 'STS', 'BAL', 'TIC'].includes(command))
          service = { ...service, accountFacade: this.accountFacade };

        // race
        if (['URC', 'FI', 'RCN', 'RCL', 'RO', 'PO', 'PM'].includes(command))
          service = { ...service, wagerFacade: this.wagerFacade };

        // tickets
        if (tickets.includes(command))
          service = { ...service, wagerFacade: this.wagerFacade };

        if (command === 'TP')
          service = { ...service, myBets: this.myBets, accountFacade: this.accountFacade };

        this.pusherService.commandController(command, data, service);

      });


    this.wagerFacade.getSelectEventTrackRaceState$()
      .subscribe(eventTrackRace => {
        if (eventTrackRace?.error || eventTrackRace?.isLoaded) this.showLoadingOverLap = false;
      });

    this.wagerFacade.getSelectedEventTrack$()
      .subscribe((selectedEventTrack?: IGetEventsDetailsResponse) => {
        // if (selectedEventTrack !== undefined) {
        //   this.selectedEvent = selectedEventTrack;
        //   this.playLiveVideo = true;
        // }
        // console.log('selectedEventTrack ', selectedEventTrack);
        this.pusherService.setSelectedEventTrack(selectedEventTrack);
        // this.cdRef.markForCheck(); // re-render for template
      });

    this.wagerFacade.getSelectedRace$()
      .subscribe((race?: ISelectedRace) => {
        if (!race || !race?.RaceId || !race?.runId || !race?.eventId) return;

        this.pusherService.setSelectedRace(race);
      });


    this.setupIonicIcons();

    this.commonFacade.isDismissModal$().subscribe((isDismiss: boolean) => {
      if (isDismiss) {
        this.loadingModal.dismiss();
        this.cdRef.markForCheck(); // re-render for template
      }
    });

    this.commonFacade.setIsShowNavigation(true);
    this.commonFacade.setIsShowFooter(true);

    this.commonFacade.isShowNavigation$().subscribe((isShow: boolean) => {
      this.isShowNavigation = isShow;
      this.cdRef.markForCheck(); // re-render for template
    });

    this.commonFacade.isAuthenticated$().subscribe((isAuth: boolean) => {
      this.isAuthenticated = isAuth;

      // responsd to inactivity
      this.inactivityService.callback = () => {
        if (this.isAuthenticated)
          this.ngZone.run(() => this.authFacade.logout(INACTIVE));
        else {
          // exit app to stop background processes such as Pusher, API request, and observables
          // ...that cause battery life and to slow phone
          setTimeout(() =>
            App.exitApp(),
            3000 // execute after 3 seconds
          );
        }
      };

      this.cdRef.markForCheck(); // re-render for template
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.commonFacade.isErrorAPI$().subscribe((error: any) => {
      // console.log(error);
      if (error?.from) {
        this.showAlertInfo('Error', error.message);
        return;
      }

      if (error) this.presentToast(error.message);
    });

    this.authFacade.isLoggingIn$().subscribe((isLoggingIn: boolean | undefined) => {
      if (isLoggingIn && !this.sessionService.getPrevUrl())
        this.showLoading('Logging into AmWager...');
      else if (this.loadingModal) this.loadingModal.dismiss();

      if (this.sessionService.getPrevUrl()) {
        this.sessionService.delPrevUrl(this.sessionService.getOptions('/', 30));
      }
    });

    this.authFacade.isRenewingPassword$().subscribe((isRenewingPassword: boolean | undefined) => {
      if (isRenewingPassword) this.showLoading('Renewing password...');
      else if (this.loadingModal) this.loadingModal.dismiss();
    });

    this.authFacade.isRegistering$().subscribe((isRegistering: boolean | undefined) => {
      if (isRegistering) this.showLoading('Signing up into AmWager...');
      else if (this.loadingModal) this.loadingModal.dismiss();
    });

    this.authFacade.isCompleteRegistering$().subscribe(
      (isCompleteRegistering: boolean | undefined) => {
      if (isCompleteRegistering) this.showLoading('Complete registering...');
      else if (this.loadingModal) this.loadingModal.dismiss();
      }
    );

    this.authFacade.isDocumentsVerificating$().subscribe(
      (isDocumentsVerificating: boolean | undefined) => {
        if (isDocumentsVerificating) this.showLoading('Uploading documents...');
        else if (this.loadingModal) this.loadingModal.dismiss();
    });

    this.authFacade.isUpdatingPassword$().subscribe((isUpdatingPassword: boolean | undefined) => {
      if (isUpdatingPassword) this.showLoading('Updating password...');
      else if (this.loadingModal) this.loadingModal.dismiss();
    });

    this.authFacade.getUserFullName$().subscribe((fullName?: string) => {
      this.userName = fullName
        || this.sessionService.getUserFName() + ' ' + this.sessionService.getUserLast();

      // if (this.sessionService.getRoleId() === 9 &&
      //     this.router.url === 'wager')
      //     this.router.navigate(['/complete-registration']);
      //   this.showMessageToCompleteRegistration();

      // if (this.sessionService.getRoleId() === 11 )
      //   this.router.navigate(['/documents-verification']);
          // && this.router.url === 'documents-verification')
        // this.showMessageToVerifiyDocuments();

      this.cdRef.markForCheck(); // re-render for template
    });

    this.authFacade.isLoginSuccessResponse$().subscribe(async(response?: any) => {

      if (
        response === undefined ||
        this.sessionService.getRoleId() === 10 ||
        this.router.url === '/complete-registration' ||
        this.router.url === '/documents-verification'
      )
        return;

      if (this.sessionService.getRoleId() === 12) {
        this.showAlertInfo('Info', 'Verification still in progress. Please wait.');
        return;
      }

      const result = await this.geoLocationService.askPermissionGeoLocation();

      if ('latitude' in result && 'longitude' in result) {
        if (result === undefined)
          return;

        if (result.latitude && result.longitude) {
          this.wagerFacade.setGeoLocation({
            CLat: result.latitude, CLon: result.longitude
          },
          'AppComponent:constructor');
        }
      }
    });

    this.authFacade.isCompleteRegistrationSuccess$()
    .subscribe(async ({isSuccessCompleteRegistration}) => {

      if (
        isSuccessCompleteRegistration === undefined ||
        isSuccessCompleteRegistration === false
      ) return;

      this.showAlertInfo('Info', 'Verification success. Your ID has been verified.');

      const result = await this.geoLocationService.askPermissionGeoLocation();

      if ('latitude' in result && 'longitude' in result) {
        if (result === undefined)
          return;

        if (result.latitude && result.longitude) {
          this.wagerFacade.setGeoLocation({
            CLat: result.latitude, CLon: result.longitude
          },
          'AppComponent:constructor');
        }
      }

    });

    this.authFacade.isDocumentsVerificationSuccess$()
    .subscribe(async ({isSuccessDocumentsVerification}) => {

      if (
        isSuccessDocumentsVerification === undefined ||
        isSuccessDocumentsVerification === false
      ) return;

      // re-commit PMM-364
      this.showAlertInfo(
        'Info',
        'Thank you for submitting your documentation. ' +
        'We will send a notification once they have been reviewed.'
      );

    });

    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
      if (isLogout) {
        this.userName = '';

        this.betSummary = false;

        this.alertHandler?.dismiss();
        this.modalVideo?.dismiss();
        this.profileModal?.dismiss();
        this.modalCtrl?.dismiss();

        this.cdRef.markForCheck(); // re-render for template
      }
    });

    this.accountFacade.getBalance$().subscribe((balance) => {

      this.balance = balance;
      this.checkAmountBalanceWidth();
      this.cdRef.markForCheck();
    });


    // test separate live video
    // this.wagerFacade.getEventLiveVideo$()
    //   .subscribe(async(response) => {
    //     console.log('response... live vids');
    //     console.log(response);
    //     if (response !== undefined) {
    //       if (!response.Error) {
    //         console.log(response.Link);
    //         this.liveVideo = response.Link;
    //         this.playLiveVideo = true;
    //       }
    //     }
    //     this.cdRef.markForCheck();
    //   });

    this.wagerFacade.getRaceResult$()
      .subscribe(async (results?: IToteResultResponse) => {
        // console.log(results);
        // console.log(results + ' here reply video');

        if (results?.errorMsg !== undefined && results?.errorMsg) {
            this.showAlertInfo(
              'Error',
              results?.errorMsg === 'Cannot find file name' ?
                'Cannot get video.'
              :
                results?.errorMsg
            );
            return;
        }

        if (!results || !results?.replayVideo || this.modalVideo) return;

        this.modalVideo = await this.modalCtrl.create({
          component: PlayVideoComponent,
          cssClass: 'play-video'
        });
        this.modalVideo.present();

        this.modalVideo.onWillDismiss().then(() => {
          this.modalVideo = undefined;
        });
      });

    this.wagerFacade.getLatestFinishedEvent$()
      .subscribe((callback) => {
        if (callback === undefined) return;

        this.profileModal.dismiss();
        this.cdRef.markForCheck();
      });

    if (this.sessionService.getUserFName())
      this.accountFacade.getAccountPreferencesAPI();

    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkAppMode();
      });

  }

  ngOnInit(): void {


    this.showLoadingOverLap = true;

    this.betSummary = false;
    this.TicketCounter = {};
    this.stackedTicketAmount = 0;
    this.activeTicketAmount = 0;
    this.closeTicketAmount = 0;
    this.closeEarnings = 0;

    this.stackTodaySum = '';
    this.betTodaySum = '';
    this.wonTodaySum = '';
    this.profitLossSum = '';
    this.activeBetsSum = '';
    this.realTimePlSum = '';

    // tmsid
    this.commonFacade.setTmsId(this.sessionService.generateSessionId());

    // check session if still active
    this.toteProgramAPIService.getState$().pipe(catchError(error => {
      this.showLoadingOverLap = false;
      this.cdRef.markForCheck();

      // Todo: separate this as standalone function, http-interceptor is using
      // if no session then auto logout, only initialization of the app
      this.commonFacade.logError(error, 'Router guard!');
      this.sessionService.resetLogout();
      this.commonFacade.setIsAuthenticated(false, "AppComponent:ngOnInit");

      // auto logged-in as guest if no user session in the server
      this.authFacade.loginGuest();

      // this.accountFacade.getBalance("AppComponent:ngOnInit");

      this.redirectToHomeScreen();

      return throwError(() => error);

    })).subscribe((state: unknown) => {
      // console.log('state:', state)

      this.wagerFacade.getEventsDetails("AppComponent:ngOnInit");

      if (Boolean(state) && this.sessionService.hasToken()) {

        this.commonFacade.setIsAuthenticated(true, "AppComponent:ngOnInit");

        // this.authFacade.setUserFullName(this.sessionService.getUserFName() + ' ' + this.sessionService.getUserLast());

        this.showLoadingOverLap = false;
        this.cdRef.markForCheck();

        // redirect to home screen when has session and token for every init of app
        this.redirectToHomeScreen();

        // tmsid
        this.commonFacade.setTmsId(this.sessionService.generateSessionId());
        this.accountFacade.getBalance("AppComponent:ngOnInit");
      }

    });

    this.wagerFacade.getTicketGeoLocation$().subscribe((response?: IGeoLocationModel) => {
      if (response === undefined) return;
      this.geoLocation = response;
    });

    // console.log('on page load.....');
    // this.getSelectedEventTrackSubs = this.wagerFacade.getSelectedEventTrack$()
    // // .pipe(take(2))
    // .subscribe((res) => {
    //   if (res?.ToteResponse) {
    //     console.log('on page load.....22222222222222222222222222');
    //     this.wagerFacade.getCountersAPI(
    //       res?.ToteResponse.RunId,
    //       'BetSummarySectionPage:ngOnInit'
    //     );

    //     if (this.getSelectedEventTrackSubs) this.getSelectedEventTrackSubs.unsubscribe();
    //   }

    // });

    // // this.subsGetCounterResponse =
    // this.wagerFacade.getCounters$()
    // // .pipe(take(2))
    // .subscribe((res) => {
    //   console.log('resssssssssssssssssssssssssssssssss');
    //   console.log(res);

    //   if (res !== undefined) {
    //     this.handleCounter('5899', res);
    //   }
    //   else {
    //     this.stackTodaySum = '0';
    //     this.betTodaySum = '0';
    //     this.wonTodaySum = '0';
    //     this.profitLossSum = '0';
    //     this.activeBetsSum = '0';
    //     this.realTimePlSum = '0';
    //   }
    //   // this.subsGetCounterResponse?.unsubscribe();
    //   this.cdRef.markForCheck();
    //   // this.cdRef.detectChanges();
    // });

    // this.checkTheme();
    this.checkAppMode();
  }

  ngAfterViewInit(): void {

    this.accountFacade.isGetAccountPreferencesSuccess$()
      .subscribe((callback) => {

        if (callback?.isSuccess === undefined) return;

        const response = callback?.response?.AccountPreferences;

        this.amWagerTheme = response?.AmWagerTheme;
        this.darkMode = this.amWagerTheme === 4 ? true : false;

        this.amwagerThemeMode(this.darkMode);

        this.cdRef.markForCheck();
      });

    if (this.amWagerTheme === undefined)
      this.checkAppMode();
    // this.checkAmountBalanceWidth();
  }

  ngOnDestroy(): void {
    // pusher
    this.pusherService.disconnect();
  }

  // for QA testing
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  qaTestingFn(toggle: any): void {
    this.commonFacade.setQaTesting({...this.qaTesting, ...toggle});
  }

  initApp() {
    // TODO: check solution
    this.platform.backButton.subscribeWithPriority(10, async () => {

      // auto select current race if coming from login page
      if (this.router.url === '/login') {
        this.router.navigate(['wager']);
        this.commonFacade.setBackNavigation('login');
        return;
      }

      if (
        this.router.url === '/success-request-reset-password' ||
        this.router.url === '/success-update-password'
      ) {
        return;
        // this.router.navigate(['/login']);
      }
      else if (this.canGoBack() && this.router.url !== '/wager') {
        this.location.back();
      }
      else {
        if (this.alertHandler) {
          this.alertHandler?.dismiss();
          this.alertHandler = undefined;
        }

        this.alertHandler = await this.alertCtrl.create({
          header: 'Confirm',
          message: 'Do you want to exit the app?',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
              }
            },
            {
              text: 'Exit',
              handler: () => {
                App.exitApp();
              }
            }
          ]
        });

        await this.alertHandler.present();

      }
    });
  }

  // async playVideo(): Promise<void> {
  //   if (!this.hasPermission()) return;

  //   if (this.selectedEvent !== undefined) {
  //     this.playLiveVideo = !this.playLiveVideo;

  //     if (
  //       !['Final', 'Finished'].includes(this.selectedEvent?.ToteResponse?.EventDetail?.EventStatus)
  //     ) {
  //       // get video
  //       this.wagerFacade.getEventRaceVideoLive(
  //         'WagerComponent:constructor',
  //         {
  //           toteEventId: this.selectedEvent?.ToteResponse?.EventDetail?.EventId,
  //           width: 720,
  //           height: 576
  //         },
  //         this.selectedEvent?.VideoType === 'IGB' ? 'IGB' : 'default'
  //       );
  //     }
  //   }

  //   this.cdRef.detectChanges();
  // }

  // closeVideo() {
  //   this.playLiveVideo = !this.playLiveVideo;
  // }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isTicketCounterSet(status: any, runId: any, eventId: any, raceId: any): boolean {
    let result = false;
    if(typeof raceId !== 'undefined'){
        try{
            if(typeof this.TicketCounter[status][runId][eventId][raceId] === 'undefined')
              result = false;
            result = true;
        }
        catch (e){
            result = false;
        }
    }
    if(typeof eventId !== 'undefined'){
        try{
            if(typeof this.TicketCounter[status][runId][eventId] === 'undefined')
                result = false;
            result = true;
        }
        catch (e){
            result = false;
        }
    }
    if(typeof runId !== 'undefined'){
        try{
            if(typeof this.TicketCounter[status][runId] === 'undefined')
                result = false;
            result = true;
        }
        catch (e){
            result = false;
        }
    }
    if(typeof status !== 'undefined'){
        try{
          this.TicketCounter[status];
            result = true;
        }
        catch (e){
            result = false;
        }
    }

    return result;
  }

  updateBetSummary(runId: string): void {
    if (this.isTicketCounterSet(STATUS_STACK, undefined, undefined, undefined) &&
        this.isTicketCounterSet(STATUS_STACK, undefined, undefined, undefined)) {
        this.stackedTicketAmount = this.TicketCounter[STATUS_STACK][runId]['TotalTicketAmounts'];
    }

    if (this.isTicketCounterSet(STATUS_ACTIVE, undefined, undefined, undefined) &&
        this.isTicketCounterSet(STATUS_ACTIVE, undefined, undefined, undefined)) {
          this.activeTicketAmount = this.TicketCounter[STATUS_ACTIVE][runId]['TotalTicketAmounts'];
    }

    if (this.isTicketCounterSet(STATUS_CLOSE, undefined, undefined, undefined) &&
        this.isTicketCounterSet(STATUS_CLOSE, undefined, 'TotalTicketAmounts', undefined)) {
          this.closeTicketAmount = this.TicketCounter[STATUS_CLOSE][runId]['TotalTicketAmounts'];
    }

    if (this.isTicketCounterSet(STATUS_CLOSE, undefined, undefined, undefined) &&
        this.isTicketCounterSet(STATUS_CLOSE, runId, 'TotalEarnings', undefined)) {
          this.closeEarnings = this.TicketCounter[STATUS_CLOSE][runId]['TotalEarnings'];
    }

    // if (this.stackedTicketAmount !== undefined)
      this.stackTodaySum = parseFloat(this.stackedTicketAmount.toString()).toFixed(2);

    // if (this.activeTicketAmount !== undefined && this.closeTicketAmount !== undefined)
      this.betTodaySum = parseFloat(
        (this.activeTicketAmount + this.closeTicketAmount).toString()
      ).toFixed(2);

    // if (this.closeEarnings !== undefined)
      this.wonTodaySum = parseFloat(this.closeEarnings.toString()).toFixed(2);

    // if (this.closeEarnings !== undefined &&
    //     this.closeTicketAmount !== undefined &&
    //     this.activeTicketAmount !== undefined)
      this.profitLossSum = parseFloat(
        (this.closeEarnings - this.closeTicketAmount - this.activeTicketAmount).toString()
      ).toFixed(2);

    // if (this.activeTicketAmount !== undefined)
      this.activeBetsSum = parseFloat(this.activeTicketAmount.toString()).toFixed(2);

    // if (this.closeEarnings !== undefined && this.closeTicketAmount !== undefined)
      this.realTimePlSum = parseFloat(
        (this.closeEarnings - this.closeTicketAmount).toString()
      ).toFixed(2);
  };

  handleCounter(runId: string, counter: ICounterModel): void {
    if(typeof counter !== 'undefined') {
      if(typeof this.TicketCounter[STATUS_STACK] === 'undefined')
      this.TicketCounter[STATUS_STACK] = {};

      if(typeof this.TicketCounter[STATUS_ACTIVE] === 'undefined')
      this.TicketCounter[STATUS_ACTIVE] = {};

      if(typeof this.TicketCounter[STATUS_CLOSE] === 'undefined')
      this.TicketCounter[STATUS_CLOSE] = {};

      if(typeof this.TicketCounter[STATUS_STACK][runId] === 'undefined')
        this.TicketCounter[STATUS_STACK][runId] = {
          'RunIdCounter':0,
          'TotalTicketAmounts':0,
          'TotalEarnings':0,
          'TotalCancelAmounts':0,
          'CancelCounter':0
        };

      this.TicketCounter[STATUS_STACK][runId]['RunIdCounter'] = counter.CountStacked;
      this.TicketCounter[STATUS_STACK][runId]['TotalTicketAmounts'] = counter.TotalStacked;

      if(typeof this.TicketCounter[STATUS_ACTIVE][runId] === 'undefined')
        this.TicketCounter[STATUS_ACTIVE][runId] = {
          'RunIdCounter':0,
          'TotalTicketAmounts':0,
          'TotalEarnings':0,
          'TotalCancelAmounts':0,
          'CancelCounter':0
        };

      this.TicketCounter[STATUS_ACTIVE][runId]['RunIdCounter'] = counter.CountActive;
      this.TicketCounter[STATUS_ACTIVE][runId]['TotalTicketAmounts'] = counter.TotalActive;

      if(typeof this.TicketCounter[STATUS_CLOSE][runId] === 'undefined')
        this.TicketCounter[STATUS_CLOSE][runId] = {
          'RunIdCounter':0,
          'TotalTicketAmounts':0,
          'TotalEarnings':0,
          'TotalCancelAmounts':0,
          'CancelCounter':0
        };

      this.TicketCounter[STATUS_CLOSE][runId]['RunIdCounter'] = counter.CountClosed;
      this.TicketCounter[STATUS_CLOSE][runId]['TotalTicketAmounts'] = counter.TotalClosed;
      this.TicketCounter[STATUS_CLOSE][runId]['TotalEarnings'] = counter.WinningsClosed;

      if(typeof counter.Closed !== 'undefined') {
        for(const closedEventId in counter.Closed)
        {
          if(typeof this.TicketCounter[STATUS_CLOSE][runId][closedEventId] === 'undefined')
            this.TicketCounter[STATUS_CLOSE][runId][closedEventId] = {
              'EventIdCounter':0,
              'TotalTicketAmounts':0,
              'TotalEarnings':0,
              'TotalCancelAmounts':0,
              'CancelCounter':0,
              'LastSold':''
            };

          this.TicketCounter[STATUS_CLOSE][runId][closedEventId]['EventIdCounter'] =
            counter.Closed[closedEventId].Count;
          this.TicketCounter[STATUS_CLOSE][runId][closedEventId]['TotalTicketAmounts'] =
            counter.Closed[closedEventId].Total;
          this.TicketCounter[STATUS_CLOSE][runId][closedEventId]['TotalEarnings'] =
            counter.Closed[closedEventId].Winnings;
          this.TicketCounter[STATUS_CLOSE][runId][closedEventId]['CancelCounter'] =
            counter.Closed[closedEventId].CountCancelled;
          this.TicketCounter[STATUS_CLOSE][runId][closedEventId]['LastSold'] =
            counter.Closed[closedEventId].Last;

          for(const closedRaceId in counter.Closed[closedEventId].Races)
          {
            if(typeof this.TicketCounter[STATUS_CLOSE][runId][closedEventId][closedRaceId] === 'undefined')
            this.TicketCounter[STATUS_CLOSE][runId][closedEventId][closedRaceId] = {
              'RaceIdCounter':0,
              'TotalTicketAmounts':0,
              'TotalEarnings':0,
              'TotalCancelAmounts':0,
              'CancelCounter':0,
              'LastSold':''
            };

            this.TicketCounter[STATUS_CLOSE][runId][closedEventId][closedRaceId]['RaceIdCounter'] =
              counter.Closed[closedEventId].Races[closedRaceId].Count;
            this.TicketCounter[STATUS_CLOSE][runId][closedEventId][closedRaceId]['TotalTicketAmounts'] =
              counter.Closed[closedEventId].Races[closedRaceId].Total;
            this.TicketCounter[STATUS_CLOSE][runId][closedEventId][closedRaceId]['TotalEarnings'] =
              counter.Closed[closedEventId].Races[closedRaceId].Winnings;
            this.TicketCounter[STATUS_CLOSE][runId][closedEventId][closedRaceId]['CancelCounter'] =
              counter.Closed[closedEventId].Races[closedRaceId].CountCancelled;
            this.TicketCounter[STATUS_CLOSE][runId][closedEventId][closedRaceId]['LastSold'] =
              counter.Closed[closedEventId].Races[closedRaceId].Last;
          }
        }
      }

      if(typeof counter.Active !== 'undefined') {
        for(const activeEventId in counter.Active)
        {
          if(typeof this.TicketCounter[STATUS_ACTIVE][runId][activeEventId] === 'undefined')
              this.TicketCounter[STATUS_ACTIVE][runId][activeEventId] = {
                'EventIdCounter':0,
                'TotalTicketAmounts':0,
                'TotalEarnings':0,
                'TotalCancelAmounts':0,
                'CancelCounter':0,
                'LastSold':''
              };

          this.TicketCounter[STATUS_ACTIVE][runId][activeEventId]['EventIdCounter'] =
            counter.Active[activeEventId].Count;
          this.TicketCounter[STATUS_ACTIVE][runId][activeEventId]['TotalTicketAmounts'] =
            counter.Active[activeEventId].Total;
          this.TicketCounter[STATUS_ACTIVE][runId][activeEventId]['CancelCounter'] =
            counter.Active[activeEventId].CountCancelled;
          this.TicketCounter[STATUS_ACTIVE][runId][activeEventId]['LastSold'] =
            counter.Active[activeEventId].Last;

          for(const activeRaceId in counter.Active[activeEventId].Races)
          {
              if(typeof this.TicketCounter[STATUS_ACTIVE][runId][activeEventId][activeRaceId] === 'undefined')
              this.TicketCounter[STATUS_ACTIVE][runId][activeEventId][activeRaceId] = {
                'RaceIdCounter':0,
                'TotalTicketAmounts':0,
                'TotalEarnings':0,
                'TotalCancelAmounts':0,
                'CancelCounter':0,
                'LastSold':''
              };

              this.TicketCounter[STATUS_ACTIVE][runId][activeEventId][activeRaceId]['RaceIdCounter'] =
                counter.Active[activeEventId].Races[activeRaceId].Count;
              this.TicketCounter[STATUS_ACTIVE][runId][activeEventId][activeRaceId]['TotalTicketAmounts'] =
                counter.Active[activeEventId].Races[activeRaceId].Total;
              this.TicketCounter[STATUS_ACTIVE][runId][activeEventId][activeRaceId]['CancelCounter'] =
                counter.Active[activeEventId].Races[activeRaceId].CountCancelled;
              this.TicketCounter[STATUS_ACTIVE][runId][activeEventId][activeRaceId]['LastSold'] =
                counter.Active[activeEventId].Races[activeRaceId].Last;
          }
        }
      }

      if(typeof counter.Stacked !== 'undefined') {
        for(const stackedEventId in counter.Stacked)
        {
          if(typeof this.TicketCounter[STATUS_STACK][runId][stackedEventId] === 'undefined')
              this.TicketCounter[STATUS_STACK][runId][stackedEventId] = {
                'EventIdCounter':0,
                'TotalTicketAmounts':0,
                'TotalEarnings':0,
                'TotalCancelAmounts':0,
                'CancelCounter':0,
                'LastSold':''
              };

          this.TicketCounter[STATUS_STACK][runId][stackedEventId]['EventIdCounter'] =
            counter.Stacked[stackedEventId].Count;
          this.TicketCounter[STATUS_STACK][runId][stackedEventId]['TotalTicketAmounts'] =
            counter.Stacked[stackedEventId].Total;
          this.TicketCounter[STATUS_STACK][runId][stackedEventId]['CancelCounter'] =
            counter.Stacked[stackedEventId].CountCancelled;
          this.TicketCounter[STATUS_STACK][runId][stackedEventId]['LastSold'] =
            counter.Stacked[stackedEventId].Last;

          for(const stackedRaceId in counter.Stacked[stackedEventId].Races)
          {
              if(typeof this.TicketCounter[STATUS_STACK][runId][stackedEventId][stackedRaceId] === 'undefined')
              this.TicketCounter[STATUS_STACK][runId][stackedEventId][stackedRaceId] = {
                'RaceIdCounter':0,
                'TotalTicketAmounts':0,
                'TotalEarnings':0,
                'TotalCancelAmounts':0,
                'CancelCounter':0,
                'LastSold':''
              };

              this.TicketCounter[STATUS_STACK][runId][stackedEventId][stackedRaceId]['RaceIdCounter'] =
                counter.Stacked[stackedEventId].Races[stackedRaceId].Count;
              this.TicketCounter[STATUS_STACK][runId][stackedEventId][stackedRaceId]['TotalTicketAmounts'] =
                counter.Stacked[stackedEventId].Races[stackedRaceId].Total;
              this.TicketCounter[STATUS_STACK][runId][stackedEventId][stackedRaceId]['CancelCounter'] =
                counter.Stacked[stackedEventId].Races[stackedRaceId].CountCancelled;
              this.TicketCounter[STATUS_STACK][runId][stackedEventId][stackedRaceId]['LastSold'] =
                counter.Stacked[stackedEventId].Races[stackedRaceId].Last;
          }
        }
      }
    }

    if (counter !== undefined) {
      this.updateBetSummary(runId);
    }
  }

  async showMessageToCompleteRegistration() {
    // const alert = await this.alertCtrl.create({
    //   header: 'Welcome!',
    //   message:
    //     "Congratulations, you've logged in successfully <br/>" +
    //     "Tap <a routerLink='/complete-registration'> here </a> to complete the Regisration!",
    //   buttons: ['OK']
    // });

    // await alert.present();

    // // Handle the click event on the link
    // const { role } = await alert.onDidDismiss();
    // if (role === 'link') {
    //   // Navigate to page
    //   this.router.navigate(['/complete-registration']);
    // }

    const modal = await this.modalCtrl.create({
      component: ShowMessageToCompleteRegistrationComponent,
      // componentProps: {
      //   destination: '/complete-registration'
      // }
    });

    await modal.present();
  }

  async showMessageToVerifiyDocuments() {
    const modal = await this.modalCtrl.create({
      component: ShowMessageToVerifiyDocumentsComponent,
    });

    await modal.present();
  }

  canGoBack(): boolean {
    // Check history stack
    return this.location.getState() !== undefined && this.location.getState() !== null;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth <= 410) {
      this.checkAmountBalanceWidth();
    } else {
      this.checkAmountBalanceWidth(true);
    }
  }

  private checkAmountBalanceWidth(windowLimitSize?: any) {
    const amountBalanceWidth = document.getElementById(
      'amountBalance'
    );
    const companyLogo = document.getElementById(
      'companyLogo'
    );
    const width = amountBalanceWidth?.offsetWidth;

    if (width) {
      if (width >= 100 && !windowLimitSize)
        this.renderer.setStyle(companyLogo, 'display', 'none');
      else
        this.renderer.setStyle(companyLogo, 'display', 'block');
    }

  }

  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent) {
  //   const clickedElement = event.target as HTMLElement;
  //   if (!clickedElement.closest('.container')) {
  //     this.isPopoverVisible = false;
  //   }
  // }

  @HostListener('document:click', ['$event'])
  @HostListener('document:touchstart', ['$event'])
  onDocumentClick(event: MouseEvent | TouchEvent) {
    const target = event.target as HTMLElement;
    const button = document.getElementById('openHistory');
    const div = document.getElementById('betSummary');

    if (target !== button && !div?.contains(target)) {
      this.betSummary = false;
    }
  }

  openHistory(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('AppComponent:openHistory', false);
    }

    let runId = '';
    this.betSummary = !this.betSummary;
    this.getSelectedEventTrackSubs = this.wagerFacade.getSelectedEventTrack$()
    .pipe(take(2))
    .subscribe((res) => {
      if (res?.ToteResponse) {

        runId = res?.ToteResponse.RunId;

        this.wagerFacade.getCountersAPI(
          res?.ToteResponse.RunId,
          'BetSummarySectionPage:ngOnInit'
        );

        if (this.getSelectedEventTrackSubs) this.getSelectedEventTrackSubs.unsubscribe();
      }
    });

    // this.subsGetCounterResponse =
    this.wagerFacade.getCounters$()
    .pipe(take(2))
    .subscribe((res) => {

      if (res !== undefined) {
        this.handleCounter(runId, res);
      }
      else {
        this.stackTodaySum = '0';
        this.betTodaySum = '0';
        this.wonTodaySum = '0';
        this.profitLossSum = '0';
        this.activeBetsSum = '0';
        this.realTimePlSum = '0';
      }

      this.cdRef.markForCheck();
    });
  }

  async openProfile(): Promise<void> {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('AppComponent:openProfile', false);
    }

    this.profileModal = await this.modalCtrl.create({
      component: ProfileComponent,
    });
    this.profileModal.present();

    // const modal = await this.modalCtrl.create({
    //   component: ProfileComponent,
    // });
    // modal.present();
  }

  redirectToHomeScreen(homeScreen = 'wager'): void {
    // if enable test component view for routes then skip process
    // and url has test
    if (this.isComponentView && this.router.url.includes('/test')) {
      this.commonFacade.setIsShowNavigation(false);
      return;
    }

    this.router.navigate([homeScreen]);
  }

  setupIonicIcons(): void {
    const iconMap = Object.keys(allIcons).reduce((acc, iconName: string) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (acc as any)[iconName] = (allIcons as any)[iconName];
      return acc;
    }, {});

    addIcons(iconMap);
  }

  checkTheme(): void {
     // Use matchMedia to check the user preference
     const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

     // Initialize the dark theme based on the initial
     // value of the prefers-color-scheme media query
     this.initializeDarkTheme(prefersDark.matches);

     // Listen for changes to the prefers-color-scheme media query
     prefersDark.addEventListener(
      'change', (mediaQuery) => this.initializeDarkTheme(mediaQuery.matches)
    );
  }

  // Check/uncheck the toggle and update the theme based on isDark
  initializeDarkTheme(isDark: boolean = false): void {
    this.themeToggle = isDark;
    this.toggleDarkTheme(isDark);
  }

  // Listen for the toggle check/uncheck to toggle the dark theme
  toggleChange(ev: CustomEvent): void {
    this.toggleDarkTheme(ev.detail.checked);
  }

  // Add or remove the "dark" class on the document body
  toggleDarkTheme(shouldAdd: boolean): void {
    shouldAdd = false;
    document.body.classList.toggle('dark', shouldAdd);
  }

  /**
   * component initialize check darkModeActivated if true/false
   * darkModeActivated lives in local storage cache browser
   * apply light or dark theme on initialize
   *
   * method: checkAppMode
   */
  checkAppMode(): void {
    const checkIsDarkMode = localStorage.getItem('darkModeActivated');
    checkIsDarkMode == 'true' ? (this.darkMode = true) : (this.darkMode = false);
    document.body.classList.toggle('dark', this.darkMode);

    // const toggle = this.elementRef.nativeElement.querySelector(
    //   '.custom-toggle label'
    // );
    // const toggleInput = this.elementRef.nativeElement.querySelector(
    //   '.custom-toggle input'
    // );

    // if (this.darkMode) {
    //   // toggle.classList.add('dark-mode');
    //   // toggle.classList.add('justify-start');
    //   // toggleInput.classList.add('checked');
    //   this.renderer.addClass(toggle, 'dark-mode');
    //   this.renderer.addClass(toggle, 'justify-end');
    //   this.renderer.addClass(toggleInput, 'checked');
    // }

    this.cdRef.markForCheck();
  }

  /**
   * toggle light/dark theme on click
   * darkModeActivated lives in local storage cache browser
   * set local storage darkModeActivated: true/false
   *
   * method: toggleDarkMode
   */
  toggleDarkMode(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('AppComponent:toggleDarkMode', false);
    }
    // const toggle = this.elementRef.nativeElement.querySelector(
    //   '.custom-toggle label'
    // );

    // const toggleInput = this.elementRef.nativeElement.querySelector(
    //   '.custom-toggle input'
    // );

    this.darkMode = !this.darkMode;

    // document.body.classList.toggle('dark', this.darkMode);
    if (this.darkMode) {
      // localStorage.setItem('darkModeActivated', 'true');
      // // toggle.classList.add('dark-mode');
      // // toggle.classList.add('justify-start');
      // // toggleInput.classList.add('checked');
      // this.renderer.addClass(toggle, 'dark-mode');
      // this.renderer.addClass(toggle, 'justify-end');
      // this.renderer.addClass(toggleInput, 'checked');

      if (!this.permissionService.isAllowed())
        this.amwagerThemeMode(this.darkMode);
      else
        this.accountFacade.upsertAccountPrefenceFieldAPI('AmWagerTheme', '4');
    }
    else {
      // localStorage.setItem('darkModeActivated', 'false');
      // // toggle.classList.remove('dark-mode');
      // // toggle.classList.remove('justify-start');
      // // toggleInput.classList.remove('checked');
      // this.renderer.removeClass(toggle, 'dark-mode');
      // this.renderer.removeClass(toggle, 'justify-end');
      // this.renderer.removeClass(toggleInput, 'checked');

      if (!this.permissionService.isAllowed())
        this.amwagerThemeMode(this.darkMode);
      else
        this.accountFacade.upsertAccountPrefenceFieldAPI('AmWagerTheme', '3');
    }
  }

  amwagerThemeMode(mode: boolean): void {

    const toggle = this.elementRef.nativeElement.querySelector(
      '.custom-toggle label'
    );

    const toggleInput = this.elementRef.nativeElement.querySelector(
      '.custom-toggle input'
    );

    document.body.classList.toggle('dark', mode);
    if (mode) {
      localStorage.setItem('darkModeActivated', 'true');
      this.renderer.addClass(toggle, 'dark-mode');
      this.renderer.addClass(toggle, 'justify-end');
      this.renderer.addClass(toggleInput, 'checked');
    }
    else {
      localStorage.setItem('darkModeActivated', 'false');
      this.renderer.removeClass(toggle, 'dark-mode');
      this.renderer.removeClass(toggle, 'justify-end');
      this.renderer.removeClass(toggleInput, 'checked');
    }
  }

  async openFunding(): Promise<void> {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('AppComponent:openFunding', false);
    }

    if (!this.permissionService.isAllowed()) {
      this.showAlertInfo('Info', 'You are not an Identified User.');
      return;
    }

    if (this.geoLocation === undefined) {
      const result = await this.geoLocationService.askPermissionGeoLocation();

      if ('latitude' in result && 'longitude' in result) {
        if (result === undefined)
          return;

        if (result.latitude && result.longitude) {
          this.wagerFacade.setGeoLocation({
            CLat: result.latitude, CLon: result.longitude
          },
          'AppComponent:openFunding');
        }

        const modal = await this.modalCtrl.create({
          component: FundingComponent,
        });
        modal.present();

        return;

      }
      else
        if (result.showDeviceSetting)
          this.showAlertError(result.msg, 'Yes');
        else
          this.showAlertError(result.msg, '');
        return;
    }

    const modal = await this.modalCtrl.create({
      component: FundingComponent,
    });
    modal.present();
  }

  async showAlertInfo(title: string, message: string, isDismiss = true, showButton = true): Promise<void> {
    if (this.alertHandler) {
      this.alertHandler?.dismiss();
      this.alertHandler = undefined;
    }

    this.alertHandler = await this.alertCtrl.create({
      header: title,
      message,
      buttons: showButton
        ? [
            {
              text: 'Close',
              handler: () => {
                this.ngZone.run(()=>{
                  this.modalCtrl.dismiss();
                });
              }
            }
          ]
        : [],
      backdropDismiss: isDismiss
    });

    await this.alertHandler.present();
  }

  async showAlertError(error: string, btn: string): Promise<void> {

    const platform = Capacitor.getPlatform();

    if (this.alertHandler) {
      this.alertHandler?.dismiss();
      this.alertHandler = undefined;
    }

    this.alertHandler = await this.alertCtrl.create({
      header: 'Error',
      message: error,
      buttons: [
        {
          text: 'Close',
          handler: () => {
            this.ngZone.run(()=>{
              this.modalCtrl.dismiss();
            });
          }
        },
        {
          text: btn,
          handler: () => {
            this.ngZone.run(()=>{
              if (platform === 'android') {
                NativeSettings.openAndroid({
                  option: AndroidSettings.Location,
                });
              }
              this.modalCtrl.dismiss();
            });
          }
        }
      ]
    });

    await this.alertHandler.present();
  }

  goTo(url: string): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('AppComponent:goTo', false);
    }

    this.router.navigate([url]);
  }

  logout(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('AppComponent:logout', false);
    }

    // logout
    this.authFacade.logout();
  }

  login(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('AppComponent:login', false);
    }

    this.router.navigate(['login']);
  }

  async showLoading(message: string): Promise<void> {
    this.loadingModal = await this.loadingCtrl.create({
      message,
      spinner: "circles"
    });

    this.loadingModal.present();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async openPopover(event: any) {
    const popover = await this.popoverController.create({
      component: AccountPopOverComponent,
      cssClass: 'custom-popover',
      event: event,
      translucent: true,
    });

    popover.addEventListener('ionPopoverDidPresent', () => {
      const popoverElement = document.querySelector('ion-popover');
      if (popoverElement) {
        const popoverContent =
        popoverElement.shadowRoot?.querySelector('.popover-content') as HTMLElement;
        popoverContent.style.borderRadius = '0';
      }
    });

    return await popover.present();
  }

  async presentToast(message = '', position: 'top' | 'middle' | 'bottom' = 'bottom'): Promise<void> {
    const toast = await this.toastController.create({
      message,
      position,
      buttons: [
        {
          text: 'Dismiss',
          role: 'cancel',
        },
      ]
    });

    await toast.present();
  }

  hasPermission(): boolean {
    if (this.permissionService.isAllowed()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  geolocationInterval(): void {
    // set new location every 2 minutes

    interval(120000)
      .subscribe(async () => {
        const result = await this.geoLocationService.askPermissionGeoLocation(true);

        if ('latitude' in result && 'longitude' in result) {
          if (!result) return;

          if (result.latitude && result.longitude) {
            this.wagerFacade.setGeoLocation({
              CLat: result.latitude, CLon: result.longitude
            },
            'AppComponent:geolocationInterval');
          }
        }
      });
  }

  smartlookChecker(): void {
    this.platform.pause.subscribe(() => {
      this.ngZone.run(() => {
        this.smartlook.stop(); // Pause Smartlook when app is in the background
      });
    });

    this.platform.resume.subscribe(() => {
      this.ngZone.run(() => {
        this.smartlook.start(); // Resume Smartlook when app returns to foreground
      });
    });
  }

  onDidDismissToast(): void {
    this.connectivity = {
      isOpen: false,
      message: ""
    };

    if (this.intervalConnectivitySubs) {
      this.intervalConnectivitySubs?.unsubscribe();
      this.intervalConnectivitySubs = undefined;
    }

    // half a minute
    this.intervalConnectivitySubs = interval(30000).subscribe(() => {
      if (!navigator.onLine) {
        this.connectivity = {
          isOpen: true,
          message: NO_INTERNET
        };
      }

      this.cdRef.detectChanges();
    });
  }

  checkConnectivity(): void {
    this.commonFacade.getIsConnectedInternet$()
      .subscribe((isConnectedInternet) => {
        if (isConnectedInternet?.isConnected) {
          console.log('You are online');

          if (this.alertHandler) {
            this.alertHandler?.dismiss();
            this.alertHandler = undefined;
          }

          this.connectivity = {
            isOpen: false,
            message: ""
          };

          this.pusherService.connect();
          this.cdRef.markForCheck();
        }
        else if (isConnectedInternet?.isConnected === false) {
          console.log('You are offline');

          this.wagerFacade.getSelectAllEventTrackRace$()
            .pipe(take(1))
            .subscribe((allEventTrackRace: IGetEventsDetailsResponse[]) => {
              if (allEventTrackRace.length === 0) {
                this.connectivity = {
                  isOpen: false,
                  message: ''
                };
                this.showAlertInfo('Info', NO_INTERNET, false, false);
              }
              else {
                this.alertHandler = undefined;
                this.connectivity = {
                  isOpen: true,
                  message: NO_INTERNET
                };
              }

              this.cdRef.markForCheck();

            });
        }
      });

    // check internet connection
    isOnline().subscribe((online) => {
      this.commonFacade.setIsConnectedInternet('AppComponent:checkConnectivity', online);
    });
  }

  async lockOrientation() {
    try {
      // Lock screen orientation to portrait
      await ScreenOrientation.lock({ orientation: 'portrait' });
      console.log('Screen orientation locked to portrait');
    } catch (error) {
      console.error('Error locking screen orientation:', error);
    }
  }

}
